import { z } from 'zod';
import type { ChartMeta, DataResponseBase } from '@/widgets/chartsView';
import { filtersValidator } from '@/features/filters';
import {
  DateScale,
  serializedDateRangeValueObjectValidator,
} from '@/shared/types';
import type { CHART_BASE_DIMENSION } from './constants';

export const dataConfigValidator = z.object({
  cohortDateScale: z.nativeEnum(DateScale),
  cohortDateRange: serializedDateRangeValueObjectValidator,
  revenueDateScale: z.nativeEnum(DateScale),
  revenueDateRange: serializedDateRangeValueObjectValidator,
  probabilisticAttribution: z.boolean(),
  dimension: z.string(),
  excludedSplitOptions: z.array(z.string()),
  metric: z.string(),
  showRelativeValues: z.boolean(),
  filters: filtersValidator,
});

export type DataConfig = z.infer<typeof dataConfigValidator>;

export interface Meta {
  defaultAxis: {
    dimension: string;
    metric: string;
  };
  config: ChartMeta['config'];
  dimensions: string[];
  metrics: string[];
}

export type ROIBreakdownDataResponse = DataResponseBase<
  typeof CHART_BASE_DIMENSION
>;
